import { tranStr } from "../../../utils/translation";
import { authHeader } from "../../../_helpers/auth-header";
import { sharedAPIs } from "../../../api/api-endpoints/SharedServiceEndpoints";
import isEmpty from "../../../validation/is-empty";
import xlsx from "@e965/xlsx";
import { AutoCloseModal } from "../../modal/Modal";

export async function saveCurrencyExchanges(data) {
  const { currencyExchange } = data;
  if (data.fields === null) {
    return data.setError({
      text: tranStr("Please enter currency exchange rate"),
      type: "feedback-error",
    });
  }

  data.setError({
    text: tranStr("Saving..."),
    type: "feedback-success",
  });

  const payload = JSON.stringify({ currency_exchange: data.fields });

  const url = sharedAPIs().save_currency_exchange;
  const config = {
    method: "POST",
    body: payload,
    headers: authHeader({
      authJson: true,
      authForm: false,
      guestJson: false,
    }),
  };

  let response = await fetch(url, config);
  if (response.ok) {
    currencyExchange.set(await currencyExchange.get());
    // Response OK
    return data.setError({
      text: "Saved Successfully",
      type: "feedback-success",
    });
  } else {
    // Response Not OK
    return data.setError({
      text: "Save Failed",
      type: "feedback-error",
    });
  }
}

export async function uploadCurrencyExchangeData(
  currencyExchange,
  setError,
  file,
  setUploadModal
) {
  if (file === null) {
    return setError({
      text: tranStr("Please attach file"),
      type: "feedback-error",
    });
  }

  if (isEmpty(file) && file?.name?.split(".").pop() !== "xlsx") {
    setError({
      text: "Please upload a valid Excel file",
      type: "feedback-error",
    });
    return;
  }

  setError({
    text: tranStr("Uploading..."),
    type: "feedback-success",
  });

  const formData = new FormData();
  formData.append("file", file);

  let formFields = { sourceType: "Currency Exchange" };
  formData.append("field", JSON.stringify(formFields));

  //Shared API endpoint for uploading currency exchange data
  const url = sharedAPIs().shared_service_upload_data;

  const config = {
    method: "POST",
    body: formData,
    headers: {
      ...authHeader({ authJson: false, authForm: true, guestJson: false }),
    },
  };

  let response = await fetch(url, config);
  if (response.ok) {
    // Response OK
    currencyExchange.set(await currencyExchange.get());
    setError({
      text: tranStr("Uploaded Successfully"),
      type: "feedback-success",
    });
    AutoCloseModal(setUploadModal);
  } else {
    // Response Not OK
    await response.json().then((errorData) => {
      errorData.map((error) => {
        return setError({
          text: tranStr(error.reason.message),
          type: "feedback-error",
        });
      });
    });
  }
}

export function downloadExcel(name, data, sheetNames) {
  let workbook = xlsx.utils.book_new();
  const occurrences = {};
  const maxWorksheetNameLength = 25;

  let worksheet = xlsx.utils.aoa_to_sheet(data);
  let worksheetName = sheetNames;
  worksheetName = worksheetName.substring(0, maxWorksheetNameLength);

  xlsx.utils.sheet_add_aoa(worksheet, data);

  // resolve worksheet name conflict.
  occurrences[worksheetName] = (occurrences[worksheetName] || 0) + 1;
  if (occurrences[worksheetName] > 1) {
    worksheetName = `${worksheetName} (${occurrences[worksheetName]})`;
  }
  xlsx.utils.book_append_sheet(workbook, worksheet, worksheetName);

  xlsx.writeFile(workbook, `${name}.xlsx`);
}
